import analyticsService from "./services/analyticsService";
import deviceFingerprintService from "./services/deviceFingerprintService";
import graphqlMutationService from "./services/graphqlMutationService";
import graphqlQueryService from "./services/graphqlQueryService";
import configureStore from "./utilities/configureStore";

export default configureStore({
  analyticsService,
  graphqlMutationService,
  graphqlQueryService,
  deviceFingerprintService
});
